import { render, staticRenderFns } from "./tagRecord.vue?vue&type=template&id=6e81f7aa&scoped=true"
import script from "./tagRecord.vue?vue&type=script&lang=js"
export * from "./tagRecord.vue?vue&type=script&lang=js"
import style0 from "./tagRecord.vue?vue&type=style&index=0&id=6e81f7aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e81f7aa",
  null
  
)

export default component.exports